import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react'
import './index.css';
import portalTheme from './portalTheme';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppList from './AppList';
import Login from './Login';
import PrivateRoute from './PrivateRoute';
import AppLogs from './AppLogs';
import LegacyLogList from './LegacyLogList';
import Policy from './Policy';
import UpdateDashboard from './UpdateDashboard';
import Dashboard from './Dashboard';
import MonochromeLogo from './MonochromeLogo';
import FontPreview from './FontPreview';
import VersionFooter from './VersionFooter';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      {process.env.NODE_ENV === 'development' && (
        <Route path="/font-preview" element={<ChakraProvider theme={portalTheme}><FontPreview /></ChakraProvider>} />
      )}
      <Route path="/" element={<Login />} />
      <Route path="/app" element={<App />} />
      <Route path="/active" element={<Navigate to="/updates" replace />} />
      <Route path="/regular-active" element={<Navigate to="/updates" replace />} />
      <Route path="/regularactive" element={<Navigate to="/updates" replace />} />
      <Route path="/regular_active" element={<Navigate to="/updates" replace />} />
      <Route path="/policy" element={<Policy />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/app-list"
        element={
          <PrivateRoute>
            <ChakraProvider theme={portalTheme}>
              <AppList />
            </ChakraProvider>

          </PrivateRoute>
        }
      />
      <Route
        path="/logs"
        element={
          <PrivateRoute>
            <ChakraProvider theme={portalTheme}>
              <AppLogs />
            </ChakraProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/legacy-logs"
        element={
          <PrivateRoute>
            <ChakraProvider theme={portalTheme}>
              <LegacyLogList />
            </ChakraProvider>
          </PrivateRoute>
        }
      />
      <Route path="/logs-legacy" element={<Navigate to="/legacy-logs" replace />} />
      <Route
        path="/updates"
        element={
          <PrivateRoute>
            <ChakraProvider theme={portalTheme}>
              <UpdateDashboard />
            </ChakraProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/notification-icon"
        element={
          <PrivateRoute>
            <MonochromeLogo />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <VersionFooter />
  </BrowserRouter>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
